import {
  FETCH_COMPRAS_REQUEST,
  FETCH_COMPRAS_SUCCESS,
  FETCH_COMPRAS_FAILURE,
} from "../actions/compras/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPRAS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COMPRAS_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_COMPRAS_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
